import React, { useState } from "react";
import axios from "axios";
import sha256 from "js-sha256";
import {
  getCountryAstrowowId,
  getStateAstrowowId,
} from "../services/functions";

const UserProfileForm = ({
  title,
  input,
  setInput,
  onSubmit,
  starSignOptions,
  genderOptions,
  countryOptions,
  stateOptions,
  isStateVisible,
  onCountryChange,
  onStateChange,
  birthDate,
  setBirthDate,
  onBirthTimeChange,
  resultStatus,
}) => {
  const emailHash = sha256(input.email);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);

  const fetchBirthCity = (astrowowId, city) => {
    axios
      .get(
        `https://services.astrologyanswers.com/aa/api/autocomplete?term=${city}&country=${astrowowId}`
      )
      .then((result) => {
        setAutoCompleteOptions(result.data);
      })
      .catch((error) => {
        console.error("Error fetching birth city:", error);
      });
  };

  const handleCityChange = (e) => {
    const { value } = e.target;
    setInput({ ...input, birthCity: value });
    const astrowowId =
      input.birthCountry === "United States"
        ? getStateAstrowowId(input.birthState)
        : getCountryAstrowowId(input.birthCountry);
    fetchBirthCity(astrowowId, value);
  };

  const handleAutoCompleteSelect = (city) => {
    setInput({ ...input, birthCity: city.label, birthPlaceId: city.value });
    setAutoCompleteOptions([]);
  };

  return (
    <div className="app-card shadow-lg d-flex flex-column align-items-start">
      <div className="app-card-header p-3 border-bottom-0">
        <div className="d-flex align-items-center">
          <div className="app-icon-holder me-2">
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              className="bi bi-person"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6 5c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
              ></path>
            </svg>
          </div>
          <h4 className="app-card-title">{title}</h4>
        </div>
      </div>
      <form className="w-100" onSubmit={onSubmit}>
        <div className="app-card-body px-4 w-100">
          <div className="item py-3">
            <label htmlFor="InputEmail" className="form-label">
              Email
            </label>
            <input
              type="text"
              className="form-control"
              id="InputEmail"
              value={input.email}
              disabled
              readOnly
            />
          </div>

          <div className="item py-3">
            <label htmlFor="InputEmailHash" className="form-label">
              Email Hash (SHA-256)
            </label>
            <input
              type="text"
              className="form-control"
              id="InputEmailHash"
              value={emailHash}
              disabled
              readOnly
            />
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="item py-3">
                <label htmlFor="InputFirstName" className="form-label">
                  First Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="InputFirstName"
                  name="firstName"
                  value={input.firstName}
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="item py-3">
                <label htmlFor="InputLastName" className="form-label">
                  Last Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="InputLastName"
                  name="lastName"
                  value={input.lastName}
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="item py-3">
                <label htmlFor="InputDateOfBirth" className="form-label">
                  Date of Birth
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="InputDateOfBirth"
                  value={
                    birthDate && !isNaN(birthDate)
                      ? birthDate.toISOString().split("T")[0]
                      : ""
                  }
                  onChange={(e) => {
                    const date = new Date(e.target.value);
                    setBirthDate(date);
                    setInput((prev) => ({
                      ...prev,
                      birthDay: e.target.value,
                    }));
                  }}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="item py-3">
                <label htmlFor="InputTimeOfBirth" className="form-label">
                  Time of Birth
                </label>
                <input
                  type="time"
                  id="InputTimeOfBirth"
                  className="form-control"
                  value={input.birthTime || "00:00:00"}
                  onChange={(e) =>
                    onBirthTimeChange(e.target.value || "00:00:00")
                  }
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="item py-3">
                <label htmlFor="InputStarSign" className="form-label">
                  Star Sign
                </label>
                <select
                  className="form-select"
                  id="InputStarSign"
                  name="signId"
                  value={input.signId}
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  autoComplete="off"
                >
                  {starSignOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-6">
              <div className="item py-3">
                <label htmlFor="InputGender" className="form-label">
                  Gender
                </label>
                <select
                  className="form-select"
                  id="InputGender"
                  name="gender"
                  value={input.gender}
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  autoComplete="off"
                >
                  {genderOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="item py-3">
              <label htmlFor="InputBirthCountry" className="form-label">
                Birth Country
              </label>
              <select
                className="form-select"
                id="InputBirthCountry"
                name="birthCountry"
                value={input.birthCountry}
                onChange={onCountryChange}
                autoComplete="off"
              >
                {countryOptions.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {isStateVisible && (
              <div className="item py-3">
                <label htmlFor="InputBirthState" className="form-label">
                  Birth State
                </label>
                <select
                  className="form-select"
                  id="InputBirthState"
                  name="birthState"
                  value={input.birthState}
                  onChange={onStateChange}
                  autoComplete="off"
                >
                  {stateOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="item py-3">
              <label htmlFor="InputBirthCity" className="form-label">
                Birth City
              </label>
              <input
                type="text"
                className="form-control"
                id="InputBirthCity"
                name="birthCity"
                value={input.birthCity}
                onChange={handleCityChange}
                autoComplete="off"
              />
              {autoCompleteOptions.length > 0 && (
                <ul
                  className="list-group"
                  style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                >
                  {autoCompleteOptions.map((city) => (
                    <li
                      key={city.value}
                      className="list-group-item"
                      onClick={() => handleAutoCompleteSelect(city)}
                      style={{ cursor: "pointer" }}
                    >
                      {city.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="item py-3">
              <label htmlFor="InputBirthPlaceId" className="form-label">
                Birth Place ID
              </label>
              <input
                type="text"
                className="form-control"
                id="InputBirthPlaceId"
                name="birthPlaceId"
                value={input.birthPlaceId}
                readOnly
                disabled
              />
            </div>
          </div>
        </div>
        <div className="app-card-footer p-4 mt-auto">
          <button className="btn btn-primary" type="submit">
            Save
          </button>
        </div>
        {resultStatus.status && (
          <div
            className={`alert alert-${resultStatus.alertType} fade show ms-4 me-4`}
          >
            {resultStatus.message}
          </div>
        )}
      </form>
    </div>
  );
};

export default UserProfileForm;
